
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/loops",
      function () {
        return require("private-next-pages/destinations/loops.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/loops"])
      });
    }
  